import { Box } from "@mui/material";
import React from "react";
import Sidebar from "../common/Sidebar";
import { Outlet } from "react-router-dom";

const sidebarWidth = 350;

const MainLayout = () => {
  return (
    <Box display="flex">
      {/* Sidebar */}
      <Sidebar sidebarWidth={sidebarWidth} />

      {/* Contenedor Principal */}
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          height: "calc(100vh - 64px)", // 🔥 resta AppBar
          width: { sm: `calc(100% - ${sidebarWidth}px)` },
          mt: "64px",
          overflow: "hidden", // evita scroll fantasma
        }}
      >
        <Outlet />
      </Box>
    </Box>
  );
};

export default MainLayout;